// extracted by css-extract-rspack-plugin
export default {"cls1":"VideoResults-cls1_0wS","cls2":"VideoResults-cls2_NOh VideoResults-cls1_0wS"};